export function getStrength(password) {
  const p = password || "";
  let score = 0;
  if (p.length >= 8) score++;
  if (p.length >= 12) score++;
  if (/[A-Z]/.test(p) && /[a-z]/.test(p)) score++;
  if (/\d/.test(p)) score++;
  if (/[^A-Za-z0-9]/.test(p)) score++;
  const labels = ["Too short", "Weak", "Fair", "Good", "Strong", "Excellent"];
  const colors = ["#d1d5db", "#ef4444", "#f59e0b", "#eab308", "#22c55e", "#16a34a"];
  return { score, label: labels[score] || labels[0], color: colors[score] || colors[0] };
}
